import { parseISO } from "date-fns";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  getDiasFechaInicioObra,
  getFechaLimiteExtensionObra,
  getHabilitadoGuardadoObrasConIntercambiosPendientes,
  getTiposContratista,
  postIdentificacionForm
} from "../../../../redux/actions/obra";
import CircularLoading from "../../../commons/loading/CircularLoading";
import { enumTiposGestion } from "../commons/enumTipoGestion";
import useGestionObra from "../hooks/useGestionObra";
import IdentificacionForm from "./IdentificacionForm";

const initialValues = {
  denominacionObra: "",
  numeroObraSRT: null,
  fechaInicioObra: null,
  fechaFinObra: null,
  idDependenciaEmpleador: null,
  resolucion: "",
  idTipoContratista: '',
  superficieAConstruir: "",
  numeroPlantas: "",
  observaciones: "",
  idTipoAvisoObra: null,
  fechaHastaExtensionObra: null,
  fechaSuspension: null,
  fechaFinSuspencion: null,
  fechaReinicioSuspension: null,
  fechaFinReinicioSuspension: null,
  fechaRecepcion: null,
};

const IdentificacionContainer = ({ nextForm, lastFormProps, handleCancel }) => {
  const dispatch = useDispatch();

  const tiposContratista = useSelector((state) => state.obra.tipoContratista);
  const identificacion = useSelector((state) => state.obra.postNuevaObra.identificacion);
  const fechaLimiteExtensionObra = useSelector((state) => state.obra.fechaLimiteExtensionObra.data);
  const habilitarEdicionObra = useSelector((state) => state.obra.habilitarEdicionObra);

  const [nombreTipoGestion] = useGestionObra(
    lastFormProps?.tipoAvisoObra,
    lastFormProps?.estado,
    lastFormProps?.informadoSRT,
    habilitarEdicionObra?.data
  );

  const [formModel, setFormModel] = useState();

  useEffect(() => {
    if (tiposContratista.data.length === 0) dispatch(getTiposContratista());
    dispatch(getDiasFechaInicioObra());

    if (lastFormProps?.idGestionObra) {
      dispatch(getFechaLimiteExtensionObra(lastFormProps.idGestionObra));
      // PDCA-1871
      dispatch(getHabilitadoGuardadoObrasConIntercambiosPendientes());
    }
  }, []);


  useEffect(() => {
    if (Object.keys(identificacion).length > 0) {
      setFormModel({ ...initialValues, ...identificacion });
    } else {
      setFormModel(initialValues);
    }
  }, [identificacion]);

  const handleSubmit = (values) => {

    // Validación para extensión de obra PDCA-1334
    if (
      nombreTipoGestion(values.idTipoAvisoObra) === enumTiposGestion.extension &&
      fechaLimiteExtensionObra
    ) {
      const fechaInicioObra = values.fechaInicioObra ? new Date(values.fechaInicioObra) : null;
      const fechaFinObra = values.fechaFinObra ? new Date(values.fechaFinObra) : null;
      const fechaPresentacion = new Date();
      
      if (fechaInicioObra && fechaLimiteExtensionObra) {
        const fechaLimiteAPI = parseISO(fechaLimiteExtensionObra);
        const minFecha = new Date(fechaInicioObra);
        minFecha.setHours(0, 0, 0, 0);

        const maxFecha = new Date(fechaLimiteAPI);

        if(fechaFinObra.getDate() == fechaLimiteAPI.getDate()) maxFecha.setHours(23, 59, 59, 999);

        if (fechaPresentacion < minFecha || fechaPresentacion > maxFecha) {
          toast.error("La extensión que está realizando se encuentra fuera de los plazos estipulados vigentes, por favor comunicarse con la ART");
          return;
        }
      }
    }

    dispatch(postIdentificacionForm(values));
    nextForm("Ubicación");
  };

  if (!formModel) {
    return <CircularLoading />;
  }
  return (
    <IdentificacionForm
      formModel={formModel}
      handleSubmit={handleSubmit}
      setFormModel={setFormModel}
      initialValues={initialValues}
      lastFormProps={lastFormProps}
      handleCancel={lastFormProps?.idGestionObra ? handleCancel : null}
      fechaLimiteExtensionObra={fechaLimiteExtensionObra}
    />
  );
};

export default IdentificacionContainer;
